<template>
    <sub-page :fullPage="true" class="m-addImageCourse">
        <!--<div slot="header">-->
        <!--<span>{{courseId ? $t('course.imageCoursewareMake') : $t('course.imageCoursewareMake') }}</span>-->
        <!--<el-button class="btn-header" type="danger" size="small" @click="closeFn">-->
        <!--<i class="nucfont inuc-close"></i>-->
        <!--</el-button>-->
        <!--</div>-->
        <el-row :gutter="20" style="margin-top: -10px">
            <el-col :span="24">
                <el-steps :active="active" finish-status="success" simple>
                    <el-step :title="$t('course.addBaseInfo')" icon="el-icon-edit"
                            @click.native="on_click(0)"></el-step>
                    <el-step :title="$t('course.addImage')" icon="el-icon-picture"
                            @click.native="on_click(1)"></el-step>
                </el-steps>
            </el-col>
        </el-row>

        <!-- 第一步 -->
        <transition enter-active-class="animated fadeIn">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="course-form"
                    v-if="active == 0">
                <el-row class="marBtm15" style="margin-top: 20px">
                    <el-col :span="8">
                        <el-form-item :label="$t('course.name')" prop="name" style="margin-bottom: 20px">
                            <el-input v-model="ruleForm.name" :placeholder="$t('tip.courseName')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('course.type')" prop="type" style="margin-bottom: 20px">
                            <el-select v-model="ruleForm.type" :placeholder="$t('tip.courseType')">
                                <el-option label="CT" :value="3" :disabled="ctType"></el-option>
                                <el-option label="DR" :value="4" :disabled="drType"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('c.knowledgePoint')" prop="knowledge" style="margin-bottom: 20px">
                            <el-cascader
                                v-model="ruleForm.knowledge"
                                :options="knowledgeMenu['Image']"
                                :props="cascadeProp"
                                :placeholder="$t('tip.knowledgePoint')"
                                :show-all-levels="false"
                                @change="knowledgeChange"
                                filterable
                            ></el-cascader>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="marBtm15">
                    <el-col :span="8">
                        <el-form-item :label="$t('course.courseCover')">
                            <el-upload
                                class="avatar-uploader"
                                :action="imgUpload.api"
                                :data="imgUpload.params"
                                accept=".jpg,.jpeg,.bmp,.png"
                                name="upfile"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                                :disabled="disableUploadCover"
                            >
                                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                <i class="el-icon-plus avatar-uploader-icon" :title="$t('course.addCover')" v-else></i>
                                <div class="mask" v-if="disableUploadCover">
                                    <i class="nucfont inuc-delete delete-cover" :title="$t('course.deleteCover')"
                                        @click="deleteCover"></i>
                                </div>
                                <div class="el-upload__tip" slot="tip">{{$t('course.coverTip', [2])}}</div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="16">
                        <el-row class="marBtm15">
                            <el-col :span="12">
                                <el-form-item :label="$t('c.operatorLevel')" prop="forLevel">
                                    <el-select v-model="ruleForm.forLevel" collapse-tags
                                                :placeholder="$t('tip.operatorLevel')">
                                        <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu"
                                                :key="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('train.hour')" prop="hours" style="margin-bottom: 20px">
                                    <el-input-number v-model="ruleForm.hours" controls-position="right" :min="1"
                                                    :max="1000"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('train.credit')" prop="score" style="margin-bottom: 20px">
                                    <el-input-number v-model="ruleForm.score" controls-position="right" :min="1"
                                                    :max="1000"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="23">
                                <el-form-item :label="$t('course.courseDesc')" prop="description">
                                    <el-input type="textarea"
                                            v-model="ruleForm.description"
                                            :autosize="{ minRows: 4}"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                    </el-col>
                </el-row>
                <div class="btn-group">
                    <el-button type="primary" @click="next('ruleForm')" style="padding: 14px 50px;font-size: 18px;">
                        {{$t('c.next')}}
                    </el-button>
                </div>
            </el-form>
        </transition>

        <!-- 第二步 -->
        <transition enter-active-class="animated fadeIn">
            <section id="content_form-p-2" role="tabpanel" aria-labelledby="content_form-h-2" class="body current"
                    aria-hidden="false" style="flex: 1;height: 91%;margin-top: 15px" v-show="active == 1">
                <section v-if="imageArray.length==0" class="no-image">
                    <p>{{$t('course.courseNoImg')}}</p>
                    <div class="btn-group">
                        <el-button type="primary" @click="chooseImage">{{$t('course.addImage')}}</el-button>
                    </div>
                </section>
                <section v-if="imageArray.length>0" class="image-content" style="display: flex;height: 88%">

                    <div class="add-image-btn" style="width: 5%">
                        <el-tooltip class="item" effect="dark" :content="$t('course.addImage')" placement="bottom"
                                    :hide-after="1000">
                            <el-button type="primary" class="add-image" size="small" @click="chooseImage">
                                <i class="nucfont inuc-add"></i>
                            </el-button>
                        </el-tooltip>
                    </div>
                    <div class="ppt-images">
                        <ul class="ppt-left-bar">
                            <draggable v-model="imageArray" :options="{draggable:'.image-bar-item'}">
                                <transition-group tag="section" name="drag">
                                    <li class="image-bar-item" v-for="(item,index) in imageArray" :key="item.id" :index="item.id">
                                        <div class="image-show-top">
                                            <img src="../../assets/images/map/no-img.png"
                                                v-if="item.thumbnails.length==0">
                                            <img :src="item.thumbnails[0].url" @click="showImage(index,item)" v-else>
                                        </div>
                                        <div class="image-des-btn">
                                            <span class="ppt-index">{{index + 1}}</span>
                                            <i class="nucfont inuc-close" @click="deleteImage(index,item)"></i>
                                            <span class="ppt-name">{{item.byName}}</span>
                                        </div>

                                        <!--<img :src="srcIsThumb(item)" @click="showImage(index)" v-else>-->
                                    </li>
                                </transition-group>
                            </draggable>


                        </ul>
                    </div>
                    <div class="ppt-right-bar">
                        <div class="image-show-wrap">

                            <el-radio-group class="image-type" v-model="radioType" @change="ctShow"
                                            v-if="this.ruleForm.type==3 && radioTypeShow">
                                <el-radio-button label="1">CT</el-radio-button>
                                <el-radio-button label="2">DR</el-radio-button>
                            </el-radio-group>
                            <!--<div class="image-show">-->
                            <div class="dr-canvas" ref="drcanvas">
                                <div class="dr-angles j-angles"></div>
                                <div id="canvasdr"></div>
                                <div id="canvasct"></div>
                            </div>
                            <!--</div>-->
                        </div>
                        <div class="image-des-wrap" style="width: 300px">
                            <ul class="image-info-basic">
                                <li class="image-info-item">
                                    <label class="item-name">{{$t('course.imageName')}}：</label><span
                                    class="item-content">{{imageName}}</span>
                                </li>
                                <li class="image-info-item">
                                    <label class="item-name">{{$t('c.knowledgePoint')}}：</label><span
                                    class="item-content">{{imageKnow}}</span>
                                </li>
                                <li class="image-info-item">
                                    <label class="item-name">{{$t('c.description')}}：</label><span class="item-content">{{imageDes}}</span>
                                </li>
                            </ul>
                            <div class="image-des-add">
                                <el-form class="el-form--label-top" style="padding: 0 10px">
                                    <el-form-item :label="$t('course.addImageDesc')">
                                        <el-input type="textarea" v-model="imageDesAdd"
                                                :autosize="{ minRows: 6, maxRows: 8}" maxlength="500"
                                                :placeholder="$t('course.addImageDescInfo')"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </section>
                <div class="btn-group" v-if="imageArray.length>0" style="margin-top: 25px">
                    <!--<el-button-group>-->
                    <el-button type="primary" @click="lastStep()"
                            style="margin-right: 20px;padding: 14px 50px;font-size: 18px;">{{$t('c.prev')}}
                    </el-button>
                    <el-button type="success" @click="finishStep()" :loading="submitLoading"
                            :disabled="!imageArray.length" style="padding: 14px 50px;font-size: 18px;">
                        {{$t('c.finish')}}
                    </el-button>
                    <!--</el-button-group>-->
                </div>
            </section>
        </transition>
        <image-dialog
            :type="dialog.type"
            :dialogOpen="dialog.imageDialog"
            :initData="dialog.initData"
            :imgIDs="imageArray"
            @onDialogClosed="dialog.imageDialog=false"
            @onSelectOver="chooseImageOver">

        </image-dialog>
    </sub-page>
</template>

<script>
    import {mapGetters} from 'vuex'
    import api from '@/api';
    import {Ticket, Cascade} from '@/utils';
    import SubPage from '@/components/Subpage.vue';
    import imageDialog from '@/components/Dialog/ImageDialog';
    import draggable from 'vuedraggable'

    export default {
        props: ['courseId', 'courseType'],
        data(){
            return {
                ruleForm: {
                    name: '',
                    knowledge: [],
                    forLevel: '',
                    type: '',
                    hours: 0,
                    score: 0,
                    description: '',
                    cover: ''
                },
                active: 0,
                rules: {
                    name: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                    type: [
                        {required: true, message: this.$t('tip.courseType'), trigger: 'change'}
                    ],
                    knowledge: [
                        {required: true, message: this.$t('tip.knowledgePoint'), trigger: 'change'}
                    ],
                    forLevel: [
                        {required: true, message: this.$t('tip.operatorLevel'), trigger: 'change'}
                    ],
                    hours: [
                        {required: true, message: this.$t('tip.hours'), trigger: 'change'}
                    ],
                    score: [
                        {required: true, message: this.$t('tip.credits'), trigger: 'change'}
                    ],
                    description: [
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'},
                    ],
                },
                cascadeProp: {
                    value: 'id',
                    label: 'value',
                    children: 'children'
                },
                forLevels: [],
                dialog: {
                    type: 3,
                    imageDialog: false,
                    initData: {}
                },
                imageArray: [],
                imageName: '',
                imageKnow: '',
                imageDes: '',
                imageDesAdd: '',
                currentID: '',
                isActive: false,
                knowledgeTypes: [],
                ctType: false,
                drType: false,
                imageUrl: '',
                imgUpload: {
                    api: api.fileUploadURL + '/Cover',
                    params: {
                        'access_token': Ticket.get().access_token
                    },
                },
                disableUploadCover: false,
                radioType: '1',
                currentIndex: -1,
                radioTypeShow: false,
                submitLoading: false,
                imgID:[],
            }
        },
        created() {
            this.$store.dispatch('getForLevelMenu');
            this.$store.dispatch('getKnowledgeMenu', {
                type: 'Image'
            }).then(data => {
                if (this.courseId) this.initData();
            });
            ;
        },

        computed: {
            ...mapGetters([
                'forLevelMenu',
                'knowledgeMenu',
            ]),
        },
        methods: {
            handleAvatarSuccess(res, file) {
                if (res.result) {
                    this.imageUrl = res.url;
                    this.disableUploadCover = true
                } else {
                    this.$message.error(res.message);
                }
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error(this.$t('course.coverTooBigMsg'));
                }else {
                    this.imgUpload.params.access_token = Ticket.get().access_token
                }

                return isLt2M;
            },
            deleteCover(){
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    this.imageUrl = '';
                    this.disableUploadCover = false
                }).catch(() => {
                });
            },
            //修改操作 初始化
            initData() {
                let apiGet
                if (this.courseType == 3) {
                    apiGet = api.getCTCourseDetail(this.courseId)
                } else if (this.courseType == 4) {
                    apiGet = api.getDRCourseDetail(this.courseId)
                }
                apiGet.then(res => {
                    let courseData = res.package;
                    this.ruleForm.name = courseData.name;
                    this.ruleForm.knowledge = Cascade.fullPath(this.knowledgeMenu['Image'], courseData.knowledge);
                    this.ruleForm.forLevel = courseData.forLevel;
                    this.ruleForm.type = courseData.type;
                    this.ruleForm.hours = courseData.hours;
                    this.ruleForm.score = courseData.score;
                    this.ruleForm.description = courseData.description;
                    if (courseData.cover) {
                        this.imageUrl = courseData.cover;
                        this.disableUploadCover = true
                    }
                    let images = []
                    courseData.sections.forEach(item => {
                        if(item.userImageID){
                            item.image.userType = 2
                            item.image.userImageId = item.userImageID
                        }else{
                            item.image.userType = 1
                        }
                        item.image.imageDesAdd = item.description
                        images.push(item.image)
                    })
                    this.imageArray = images;
                    this.isDisabledType();
                })
            },
            //点击步骤
            on_click(e){
                if (e == 1) {
                    if (this.$refs.ruleForm) {
                        this.$refs.ruleForm.validate((valid) => {
                            if (valid) {
                                this.active = e;
                                // console.log('submitData', this.ruleForm);
                            } else {
                                // console.log('error submit!!');
                                return false;
                            }
                        });
                    } else {
                        this.active = e;
                    }

                } else {
                    this.active = e;
                }

            },
            //下一步
            next(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.active++;
                        // console.log('submitData', this.ruleForm);
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });

            },
            //上一步
            lastStep() {
                this.active--;
                if (this.imageArray.length > 0) {
                    this.isDisabledType();
                }
            },
            isRepeat(arr,key) {
                var hash = {};
                for(var i in arr) {
                    if(hash[arr[i]]) {
                    return true;
                    }
                    // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
                    hash[arr[i]] = true;
                }
                return false;
            },
            //完成
            finishStep(){
                this.saveDes();
                if (!this.imageArray.length) {
                    this.$message(this.$t('tip.addImg'));
                    return;
                }
                let sections = [];
                let imageIDs = []
                this.imageArray.forEach((item, index) => {
                    imageIDs.push(item.id)
                    if(item.userType == 2){
                        sections.push({'order': index + 1, 'description': item.imageDesAdd || '','imageID':item.id, 'userImageID': item.userImageId})
                    }else{
                        sections.push({'order': index + 1, 'description': item.imageDesAdd || '', 'imageID': item.id,'userImageID':null})
                    }
                });
                if(this.isRepeat(imageIDs)){
                    this.$message('请删除重复图像！');
                    return
                }
                let submitData = {
                    'name': this.ruleForm.name,
                    'forLevel': this.ruleForm.forLevel,
                    'knowledge': this.ruleForm.knowledge[1],
                    'type': this.ruleForm.type,
                    'hours': this.ruleForm.hours,
                    'score': this.ruleForm.score,
                    'description': this.ruleForm.description,
                    'cover': this.imageUrl,
                    'sections': sections
                }
                this.submitLoading = true;
                if (this.courseId) {
                    let apiPost;
                    if (this.ruleForm.type == 3) {
                        apiPost = api.editCTCourse(this.courseId, submitData)
                    } else if (this.ruleForm.type == 4) {
                        apiPost = api.editDRCourse(this.courseId, submitData)
                    }
                    apiPost.then(res => {
                        this.submitLoading = false;
                        this.$notify({
                            title: res.error,
                            message: this.$t('m.editSuccess'),
                            type: 'success',
                            duration: 2000
                        });
                        this.$emit('needUpdate');
                        this.$router.replace({name: 'myCourse'})
                    }).catch(error => this.submitLoading = false);

                } else {
                    let apiPost;
                    if (this.ruleForm.type == 3) {
                        apiPost = api.postCTCourse(submitData)
                    } else if (this.ruleForm.type == 4) {
                        apiPost = api.postDRCourse(submitData)
                    }
                    apiPost.then(res => {
                        this.submitLoading = false;
                        this.$notify({
                            title: res.error,
                            message: this.$t('course.courseMakeSuccess'),
                            type: 'success',
                            duration: 2000
                        });
                        this.$emit('needUpdate');
                        this.$router.replace({name: 'myCourse'})
                    }).catch(error => this.submitLoading = false);
                }
            },
            //知识点变化
            knowledgeChange(data){
                this.ruleForm.knowledge = data;
            },
            // 打开对话框
            chooseImage() {
                this.dialog.type = parseInt(this.ruleForm.type);
                this.dialog.imageDialog = true;
                let idArray = [];
                this.imageArray.forEach(ele => {
                    let id = ele.userType == 2 ? ele.userImageId :ele.id
                    idArray.push(id);
                });
                this.dialog.initData = {
                    ids: idArray,
                    knowledge: this.ruleForm.knowledge,
                };
            },
            //选择图像完毕
            chooseImageOver(data){
                data.forEach(ele => {
                    if(ele.userType == 2){
                        if (!this.imageArray.find(arr => arr.userImageId === ele.userImageId)) {
                            this.imageArray.push(ele);
                        }
                    }else{
                        if (!this.imageArray.find(arr => arr.id === ele.id)) {
                            this.imageArray.push(ele);
                        } else {
                            let idx = this.imageArray.findIndex(arr => arr.id === ele.id)
                            if(this.imageArray[idx].userType==2){
                                this.imageArray.push(ele);
                            }
                        }
                    }
                });

            },
            //图像是否有缩略图
            srcIsThumb(item){
                let url;
                if (item.thumbnails.length > 0) {
                    url = item.thumbnails[0].url
                } else {
                    url = item.dr[0].url
                }
                return url
            },
            //展示图像
            showImage(index,itemData){
                $('.dr-canvas').show();
                let id = itemData.userType == 2 ? itemData.userImageId :itemData.id
                if (this.currentID == id) {
                    return
                } else {

                    this.currentIndex = index;
                    this.saveDes();

                    if (this.ruleForm.type == 3) {
                        this.radioTypeShow = true;
                        this.radioType = '1';
                        $("#canvasdr,.dr-angles").hide();
                        $("#canvasct").show();
                        //CT
                        let CtWidth = Math.floor($('.dr-canvas').width())
                        let CtHeight = Math.floor($('.dr-canvas').height())
                        let showSlice = false
                        if (!this.ctInstance) {
                            this.ctInstance = new CtViewerSimple({CtWidth, CtHeight, showSlice})
                        }
                        this.ctInstance.initShow(this.imageArray[index])
                    } else {
                        //DR
                        let DrWidth = Math.floor($('.dr-canvas').width())
                        let DrHeight = Math.floor($('.dr-canvas').height())
                        if (!this.drInstance) {
                            this.drInstance = new DrViewer({DrWidth, DrHeight})
                        }
                        this.drInstance.showDR(this.imageArray[index])
                    }
                    this.imageName = this.imageArray[index].byName;
                    this.imageKnow = this.imageArray[index].knowledgeName;
                    this.imageDes = this.imageArray[index].description || '';
                    this.imageDesAdd = this.imageArray[index].imageDesAdd || '';
                    this.currentID =this.imageArray[index].userType ==2 ?this.imageArray[index].userImageId : this.imageArray[index].id
                    $('.ppt-left-bar li').removeClass('active');
                    $('.ppt-left-bar').find('li:nth-child(' + (index + 1) + ')').addClass('active');
                }

            },
            //保存图像描述添加
            saveDes(){
                this.imageArray.forEach(item => {
                    let id = item.userType == 2 ? item.userImageId : item.id
                    if (id == this.currentID) {
                        item.imageDesAdd = this.imageDesAdd
                    }
                })
            },
            //删除图片
            deleteImage(index,itemData){
                let id = itemData.userType == 2 ? itemData.userImageId :itemData.id
                if(id==this.currentID){
                    $('.dr-canvas').hide();
                    this.imageName = '';
                    this.imageKnow = '';
                    this.imageDes = '';
                    this.imageDesAdd ='';
                }
                if(this.imageArray.length==1){
                    this.drInstance=undefined;
                    this.ctInstance=undefined;
                }
                this.imageArray.splice(index, 1)

            },

            //课件类型是否禁选
            isDisabledType(){
                if (this.ruleForm.type == 3) {
                    this.ctType = false;
                    this.drType = true;
                } else if (this.ruleForm.type == 4) {
                    this.ctType = true;
                    this.drType = false;
                }
            },
            closeFn() {
                if (this.courseId) {
                    this.$router.replace({name: 'myCourse'});
                    return;
                }
                this.$confirm(this.$t('m.coursingOrExit'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    this.$router.replace({name: 'myCourse'});
                }).catch(() => {
                });
            },
            ctShow(){
                if (this.radioType == 1) {
                    $("#canvasdr,.dr-angles").hide();
                    $("#canvasct").show();
                } else {
                    //DR
                    $("#canvasct").hide();
                    $("#canvasdr,.dr-angles").show();
                    let DrWidth = Math.floor($('.dr-canvas').width())
                    let DrHeight = Math.floor($('.dr-canvas').height())
                    if (!this.drInstance) {
                        this.drInstance = new DrViewer({DrWidth, DrHeight})
                    }
                    this.drInstance.showDR(this.imageArray[this.currentIndex])
                }
            },
        },
        beforeDestroy () {
            if (this.ctInstance) {
                this.ctInstance.stopRender()
            }
            if (this.drInstance) {
                this.drInstance.stopRender()
            }
        },
        destroyed() {
            this.$emit('onClose');
        },
        components: {
            SubPage,
            imageDialog,
            draggable
        }

    }
</script>
<style lang="scss">
    .m-addImageCourse {
        .course-form {
            .el-form-item__content {
                > .el-input,
                > .el-cascader,
                > .el-input-number,
                > .el-select {
                    width: 70%;
                    min-width: 220px;
                }
            }
            @media screen and (max-width: 1280px) {
                .el-col {
                    float: none;
                    width: 75%;
                }
            }
        }
        .dr-canvas {
            position: relative;
            width: 100%;
            height: 100%;
            /*border: 1px dashed #ccc;*/
            canvas {
                display: block;
            }
            .dr-angles {
                position: absolute;
                top: 5px;
                right: 5px;
                z-index: 9;
                a {
                    display: inline-block;
                    margin-right: 5px;
                    padding: 5px 8px;
                    background: #bfbfbf;
                    border-radius: 2px;
                    color: #fff;
                    cursor: pointer;
                    &.active {
                        background: #00bcd4;
                    }
                    &:hover {
                        background: #33c9dd;
                    }
                }
            }
        }

        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }

        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 220px;
            height: 178px;
            line-height: 178px;
            text-align: center;
        }
        .mask {
            position: absolute;
            left: 0;
            bottom: 0;
            right: 0;
            background-color: #000;
            opacity: 0.6;
            transition: all .3s ease-in-out;
            text-align: right;
            padding-right: 20px;
            color: #fff;
            height: 40px;
            &:hover {
                i {
                    font-size: 18px;
                }
            }
        }
        .el-upload__tip {
            margin-top: -5px;
        }

    }

    .myCoursePage {
        .sub-page .box-card {
            min-height: 98%;
        }
        .step-box .btn-group {
            text-align: center;
        }
    }

    .app-root:not(.lang-zh-CN) {
        .m-addImageCourse {
            .course-form {
                margin-left: 40px;
                .el-col {
                    float: none;
                    width: 75%;
                    max-width: 800px;
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
    .btn-group {
        margin-top: 3px;
        text-align: center;
    }

    .ppt-images {
        width: 20%;
        padding: 0 15px;
        height: 100%;
    }

    .ppt-left-bar {
        width: 100%;
        height: 100%;
        padding: 10px;
        border: 1px solid #ccc;
        border-radius: 3px;
        position: relative;
        overflow-x: hidden;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 8px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #ccc;
            border-left: 2px solid transparent;
            &:window-inactive {
                background-color: #ff6600;
                visibility: hidden;
            }
        }
        &::-webkit-scrollbar-track {
            background-color: #eee;
            border-left: 2px solid transparent;
        }
        li {
            position: relative;
            padding-left: 18px;
            padding-bottom: 4px;
            margin-bottom: 10px;
            &.active, &.active:hover {
                background-color: #f8efc0;
            }
            &:hover {
                background-color: #d5d6e2;
                i {
                    display: block;
                }
            }
            /*&.active:hover {*/
            /*i {*/
            /*display: none;*/
            /*}*/
            /*}*/
            .ppt-index {
                position: absolute;
                top: 0;
                left: 0;
                width: 15px;
                padding-top: 2px;
                text-align: center;
                font-size: 14px;
                font-weight: 600;
                color: #555;
            }
            i {
                display: none;
                position: absolute;
                top: 0;
                right: 0;
                color: #ff4081;
                z-index: 999;
                cursor: pointer;
                font-size: 18px;
            }
            .ppt-name {
                position: absolute;
                bottom: 4px;
                left: 0;
                width: calc(100% - 18px);
                margin-left: 18px;
                padding: 2px 2px 2px 4px;
                font-size: 12px;
                color: #555;
                background: #eee;
                opacity: 0.8;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            /*img {*/
            /*display: block;*/
            /*width: 100%;*/
            /*min-height: 100px;*/
            /*max-height: 150px;*/
            /*box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);*/
            /*cursor: pointer;*/
            /*}*/
            .image-show-top {
                width: 100%;
                height: 110px;
                text-align: center;
                background-color: #fff;
                cursor: pointer;
                box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
                img {
                    height: 100%;
                }
            }
        }

    }

    .add-image {
        margin-top: 200px;
    }

    .ppt-right-bar {
        width: 75%;
        height: 100%;
        border: 1px solid #ccc;
        border-radius: 3px;
        display: flex;
        justify-content: space-between;
    }

    .image-show-wrap {
        width: 70%;
        padding: 10px;
        /*height: 100%;*/
        /*height: 460px;*/
        .image-show {
            width: 100%;
            height: 100%;
            border: 1px dashed #ccc;
        }
    }

    .image-des-wrap {
        width: 20%;
        /*height: 460px;*/
        border-left: 1px dashed #cccccc;
    }

    .image-info-basic {
        height: 220px;
        padding: 10px;
        .image-info-item {
            margin-bottom: 10px;
            .item-name {
                font-weight: 600;
                color: #333;
            }
        }
    }

    .image-des-add {
        border-top: 1px dashed #ccc;
    }

    .random-select-wrap {
        padding-left: 120px;
        margin-top: -20px;
    }

    .marBtm15 {
        margin-bottom: 15px;
    }

    .el-step {
        cursor: pointer;
    }

    .no-image {
        > p {
            margin: 90px 0;
            font-size: 16px;
            color: #252525;
            text-align: center;
        }

        button {
            padding: 14px 50px;
            font-size: 18px;
        }
    }

    .image-type {
        position: absolute;
        left: 29%;
        z-index: 9;
    }

    .el-select-dropdown__item {
        width: 220px;
    }

    .avatar {
        width: 238px;
        height: 178px;
        display: block;
    }

    .course-form {
        padding-top: 25px;
    }
</style>
